"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./StickyBottomBar.css");
var StickyBottomBar = /** @class */ (function (_super) {
    __extends(StickyBottomBar, _super);
    function StickyBottomBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StickyBottomBar.prototype.render = function () {
        var cssClasses = [styles.stickyBottomBar];
        if (this.props.options && this.props.options.shadow) {
            cssClasses.push(styles.shadowed);
        }
        return (React.createElement("div", { "data-test-id": this.props.testId, className: cssClasses.join(' ') }, this.props.children));
    };
    return StickyBottomBar;
}(React.Component));
exports.default = StickyBottomBar;
//# sourceMappingURL=StickyBottomBar.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/StickyBottomBar/StickyBottomBar.js
// module id = 1414
// module chunks = 8